
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import detectLang from "utils/detectLang";

const OpenHeader = ({ tab, setTab, subTab, setSubTab, openPitch, categories }) => {
  const { t } = useTranslation();
  // const { lang: _lang } = useParams();
  // const lang = _lang || 'en';
  
  const lang = localStorage.getItem("i18nextLng") || "sp";

  const handleSubTab = (tabname) => {
    setSubTab(tabname);
    openPitch.current.scrollIntoView({ behavior: "smooth" });
  };

  console.log(categories , 'open-header');

  return (
    <>
      <div className="open-header">
        <ul className="parent">
          {
            categories?.map((item, _ind) => {
              const { services } = item;
              return <>
                <li
                  className={`parent-p ${tab == item?.id ? "active" : ''}`}
                  onClick={() => {
                    setTab(item?.id);
                    setSubTab(services[0]?.id);
                  }}
                >
                  {detectLang(item,'title',lang)} +
                </li>
                {(tab == item?.id) && (
                  <>
                    <ul className="open-header-sub-menu">
                      {
                        services?.map((sub, sub_index) => {
                          return <>
                            <li
                              className={subTab === sub?.id && "active"}
                              onClick={() => {
                                handleSubTab(sub?.id);
                              }}
                            >
                              {detectLang(sub,'title',lang)}
                            </li>
                          </>
                        })
                      }
                    </ul>
                  </>
                )}
              </>
            })
          }
        </ul>
      </div>
    </>
  );
};

export default OpenHeader;
